import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { ui } from "../lib/ui";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Account created!");
      navigate("/archive");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Sign-up failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-16">
      <h1 className="font-serif text-3xl font-bold text-[#8B1A1A] mb-2">Create account</h1>
      <p className="text-sm text-[#5A4441] mb-8">The archive is free for everyone. An account keeps your access ready for the future.</p>
      <form onSubmit={submit} className={ui.card + " p-6 space-y-5"} data-testid="register-form">
        <div>
          <label className={ui.label}>Name <span className="text-[#5A4441] font-normal">(optional)</span></label>
          <input value={name} onChange={(e) => setName(e.target.value)} className={ui.input} data-testid="register-name-input" />
        </div>
        <div>
          <label className={ui.label}>Email</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={ui.input} data-testid="register-email-input" />
        </div>
        <div>
          <label className={ui.label}>Password <span className="text-[#5A4441] font-normal">(min 6 characters)</span></label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={ui.input} data-testid="register-password-input" />
        </div>
        <button type="submit" disabled={loading} className={ui.btnPrimary + " w-full"} data-testid="register-submit-btn">
          {loading ? "Creating…" : "Create account"}
        </button>
      </form>
      <p className="text-sm text-[#5A4441] mt-5 text-center">
        Already have an account? <Link to="/login" className="text-[#8B1A1A] underline">Log in</Link>
      </p>
    </div>
  );
}
